import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconPackageSearch: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconPackageSearch"><Path d="M11.5 20.5H3.5V3.5H8.5M8.5 3.5H15.5M8.5 3.5V9.5H15.5V3.5M15.5 3.5H20.5V11.5M19.6213 19.6218C18.4497 20.7934 16.5503 20.7934 15.3787 19.6218C14.2071 18.4502 14.2071 16.5507 15.3787 15.3792C15.9645 14.7934 16.7322 14.5005 17.5 14.5005C18.2678 14.5005 19.0355 14.7934 19.6213 15.3792C20.7929 16.5507 20.7929 18.4502 19.6213 19.6218ZM19.6213 19.6218L21.5 21.5005" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconPackageSearch;
